import getData from "@/__main__/get-data.mjs";
import type { Profile } from "@/game-eft/models/graphql.mjs";
import { ProfileValidate } from "@/game-eft/models/graphql.mjs";
import * as API from "@/game-eft/utils/api.mjs";

export default async function fetchProfile(
  profileId: string,
): Promise<Profile> {
  const profile = await getData(
    API.getPlayer({ accountId: profileId }),
    ProfileValidate,
    ["eft", "profiles", profileId],
  );
  return profile;
}
